import React from 'react';
import { Award, ShieldCheck, FileText, Home, Calendar } from 'lucide-react';
export function TrustBar() {
  const stats = [{
    icon: <Award className="w-6 h-6 text-tx-navy" data-id="element-262" />,
    text: 'Owens Corning Platinum Preferred',
    subtext: '1 of only 26 in DFW'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-tx-navy" data-id="element-263" />,
    text: 'Atlas Shingles Platinum Contractor',
    subtext: 'Top tier certification'
  }, {
    icon: <FileText className="w-6 h-6 text-tx-navy" data-id="element-264" />,
    text: 'RCAT Licensed',
    subtext: '#01-0501'
  }, {
    icon: <Home className="w-6 h-6 text-tx-navy" data-id="element-265" />,
    text: '2,400+ Replacements',
    subtext: 'Insurance claim experts'
  }, {
    icon: <Calendar className="w-6 h-6 text-tx-navy" data-id="element-266" />,
    text: 'Serving Texans',
    subtext: 'Since 2017'
  }];
  return <div className="bg-tx-light border-y border-gray-200 py-8" data-id="element-267">
      <div className="container mx-auto px-4" data-id="element-268">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-4" data-id="element-269">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center text-center gap-2" data-id="element-270">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-271">
                {stat.icon}
              </div>
              <div data-id="element-272">
                <p className="font-bold text-tx-deep text-sm leading-tight" data-id="element-273">
                  {stat.text}
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-274">{stat.subtext}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}